module.exports = __webpack_public_path__ + "static/media/Illus-Thanks.78cda56b.png";